<div *ngIf="(pageVm$ | async) as pageVm">

  <div *ngIf="pageVm.error">
    <p>{{pageVm.error}}</p>
  </div>

  <p>
    this is a POC for analyzing the front email data for incoming requests from customers
    ** to be worked on more later, or deleted if not needed **
  </p>

  <p>front-analysis-page works!</p>

</div>


